const activate = (id) => {
  document.querySelectorAll('.js-article-indicator').forEach((node) => {
    node.classList.remove('is-active')
    if (node.dataset.articleId === id) node.classList.add('is-active')
  })
}

export default activate
